import { Stack } from "@mui/material"
import "./styles.scss"

export default function ResourceDetailContainer({ children }: { children: React.ReactNode }) {
    return <Stack className="resourceEditContainer" direction="row" >
        {children}
    </Stack>
}